import Vue from 'vue';
import Router from 'vue-router';

import AddressIndex from './components/address/Index';

import CustomMedicationCreate from './components/customMedications/Create';
import CustomMedicationEdit from './components/customMedications/Edit';
import CustomMedications from './components/customMedications/Index';

import DrugCardIndex from './components/drugcard/Index';
import MedicationList from './components/MedicationList';

import ForgotPassword from './components/ForgotPassword';

import Inventory from './components/Inventory';

import Login from './components/Login';

import LogsEdit from './components/logs/Edit';
import LogsIndex from './components/logs/Index';
import LogsShow from './components/logs/Show';

import PharmacyCreate from './components/pharmacies/Create';
import PharmacyEdit from './components/pharmacies/Edit';
import PharmacyIndex from './components/pharmacies/Index';
import MyPharmacy from './components/pharmacies/MyPharmacy';

import ReservationCreate from './components/reservations/Create';
import ReservationEdit from './components/reservations/Edit';
import ReservationIndex from './components/reservations/Index';

import RoleCreate from './components/roles/Create';
import RoleEdit from './components/roles/Edit';
import RoleIndex from './components/roles/Index';

import UserCreate from './components/users/Create';
import UserIndex from './components/users/Index';

import DrugSafeUserEdit from './components/users/drugSafe/Edit';

import MyAccount from './components/users/MyAccount';
import WebUserEdit from './components/users/web/Edit';

import store from './store/index';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // ADDRESSES
        {
            name: 'address.index',
            path: '/addresses',
            component: AddressIndex
        },
        // CREATE CUSTOM MEDICATION
        {
            name: 'customMedications.create',
            path: '/custom-medications/create',
            component: CustomMedicationCreate
        },
        // EDIT CUSTOM MEDICATION
        {
            name: 'customMedications.edit',
            path: '/custom-medications/edit/:vnr',
            component: CustomMedicationEdit
        },
        // CUSTOM MEDICATIONS
        {
            name: 'customMedications.index',
            path: '/custom-medications',
            component: CustomMedications
        },
        // DRUG CARD (SPECIFIC VNR)
        {
            name: 'drug_card.index',
            path: '/drug-card/medication/:vnr',
            component: DrugCardIndex
        },
        // DRUG CARD (NO VNR)
        {
            name: 'drug_card.index_novnr',
            path: '/drug-card',
            component: DrugCardIndex
        },
        // EDIT DRUGSAFE USER
        {
            name: 'drugSafeUser.edit',
            path: '/users/drugsafe/:second_id/edit',
            component: DrugSafeUserEdit,
            meta: {
                permission: 'edit_user'
            }
        },
        // HOME (NON-SUPERADMIN) (REDIRECT TO MY PHARMACY)
        {
            name: 'home',
            path: '/',
            redirect: '/my-pharmacy',
            component: MyPharmacy
        },
        // HOME (SUPERADMIN) (REDIRECT TO PHARMACIES)
        {
            name: 'home_superadmin',
            path: '/',
            redirect: '/pharmacies',
            component: MyPharmacy
        },
        // INVENTORY
        {
            name: 'inventory',
            path: '/inventory',
            component: Inventory
        },
        // EDIT LOG
        {
            name: 'log.edit',
            path: '/log/edit/:id',
            component: LogsEdit
        },
        // LOGS
        {
            name: 'logs.index',
            path: '/logs',
            component: LogsIndex
        },
        // SHOW LOG
        {
            name: 'log.show',
            path: '/log/show/:id',
            component: LogsShow
        },
        // LOGIN
        {
            name: 'login',
            path: '/login',
            component: Login
        },
        // MEDICATION LIST
        {
            name: 'medications',
            path: '/medications',
            component: MedicationList
        },
        // MY PHARMACY
        {
            name: 'my_pharmacy',
            path: '/my-pharmacy',
            component: MyPharmacy
        },
        // CREATE PHARMACY
        {
            name: 'pharmacy.create',
            path: '/pharmacies/create',
            component: PharmacyCreate,
            meta: {
                permission: 'superadmin'
            }
        },
        // EDIT PHARMACY
        {
            name: 'pharmacy.edit',
            path: '/pharmacies/:id/edit',
            component: PharmacyEdit,
            meta: {
                permission: 'edit_pharmacy'
            }
        },
        // PHARMACIES
        {
            name: 'pharmacy.index',
            path: '/pharmacies/',
            component: PharmacyIndex,
            meta: {
                permission: 'superadmin'
            }
        },
        // CREATE RESERVATION
        {
            name: 'reservation.create',
            path: '/reservations/create',
            component: ReservationCreate
        },
        // EDIT RESERVATION
        {
            name: 'reservation.edit',
            path: '/reservations/edit/:res_id',
            component: ReservationEdit
        },
        // RESERVATIONS
        {
            name: 'reservation.index',
            path: '/reservations',
            component: ReservationIndex
        },
        // RESET PASSWORD
        {
            name: 'reset-password',
            path: '/reset-password',
            component: ForgotPassword
        },
        // CREATE ROLE
        {
            name: 'role.create',
            path: '/role/create',
            component: RoleCreate,
            meta: {
                permission: 'superadmin'
            }
        },
        // EDIT ROLE
        {
            name: 'role.edit',
            path: '/role/:id/edit',
            component: RoleEdit,
            meta: {
                permission: 'superadmin'
            }
        },
        // ROLES AND PERMISSIONS
        {
            name: 'role.index',
            path: '/permissions-roles',
            component: RoleIndex,
            meta: {
                permission: 'superadmin'
            }
        },
        // CREATE USER
        {
            name: 'user.create',
            path: '/users/create',
            component: UserCreate,
            meta: {
                permission: 'create_user'
            },
            props: true
        },
        // USERS
        {
            name: 'user.index',
            path: '/users',
            component: UserIndex,
            meta: {
                permission: 'show_user'
            }
        },
        // MY ACCOUNT
        {
            name: 'user.my_account',
            path: '/user-account',
            component: MyAccount
        },
        // EDIT WEB USER
        {
            name: 'webUser.edit',
            path: '/users/web/:id/edit',
            component: WebUserEdit,
            meta: {
                permission: 'edit_user'
            }
        },
        // WEB USERS
        {
            name: 'webUser.index',
            path: '/web-users/',
            component: UserIndex,
            meta: {
                permission: 'superadmin'
            }
        }
    ]
});

const publicPages = ['login', 'reset-password']; // pages that don't require the user to be logged in

// *** before each routing action: check permissions ***
router.beforeEach(async (to, from, next) => {
    const loginRequired = !publicPages.includes(to.name); // page requires login
    const loggedIn = localStorage.getItem('token'); // id token found

    // if login required but id token not found, log out user
    if (loginRequired && !loggedIn) {
        if (store.getters['account/status'].loggedIn) {
            await store.dispatch('account/logout', { msg: 'error_session_expired' });
        }
        return next('/login');
    } else if (!loginRequired) {
        // otherwise if no login required, proceed
        store.dispatch('account/setLoadedTrue');
        return next();
    } else {
        try {
            await store.dispatch('account/getUser');
            const permissions = store.getters['account/permissions'];
            const permissionNeeded = to.meta.permission;
            if (typeof to.meta.permission !== 'undefined') {
                if (permissions[permissionNeeded]) {
                    // user has required permissions
                    next();
                } else {
                    // redirect to main page
                    next('/');
                }
            } else {
                // no permissions required -> proceed
                return next();
            }
        } catch (error) {
            console.error('could not get user profile');
        }
    }
});
